var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('number-card',{attrs:{"amount":_vm.amount,"title":_vm.$it('dealer.card.audits-planned-and-done.title', 'Planned / Performed'),"primary":""}})}
var staticRenderFns = []

export { render, staticRenderFns }